<template>
    <div class="mark-btn lr-img-scale">
        <div class="lottie-wrap">
            <img v-show="!isCollection" src="@/assets/img/collect.png">
            <lottie v-show="isCollection && !hideCollectSuccessAnim"
                    :options="markSuccessOptions"
                    :height="24"
                    :width="24"
                    @animCreated="collectSuccessAnimationCeratedHandler"
            />
            <img v-show="isCollection && hideCollectSuccessAnim" src="@/assets/img/collect-ed.png">
        </div>
    </div>
</template>

<script>
    import * as animationDataMarkFill from '@/assets/lottie-json/markfill.json'

    export default {
        name: 'LottieSubscribeBtn',
        props: {
            isCollection: {
                type: Boolean,
                default: undefined
            },
            clickCallBack: {
                type: Function,
                default: undefined
            }
        },
        data () {
            return {
                markSuccessOptions: {
                    animationData: animationDataMarkFill.default,
                    loop: false,
                    autoplay: false
                },
                markSuccessAnim: undefined,
                hideCollectSuccessAnim: false
            }
        },
        watch: {
            isCollection: {
                immediate: true,
                handler (newVal, oldVal) {
                    if (!this.markSuccessAnim) {
                        return
                    }
                    if (newVal) {
                        if (typeof oldVal === 'undefined') {
                            this.hideCollectSuccessAnim = true
                            return
                        }
                        this.markSuccessAnim.play()
                    } else {
                        this.markSuccessAnim.stop()
                        this.hideCollectSuccessAnim = false
                    }
                }
            }
        },
        created () {
        },
        mounted () {
        },
        methods: {
            collectSuccessAnimationCeratedHandler (anim) {
                this.markSuccessAnim = anim
                this.markSuccessAnim.addEventListener('complete', () => {
                    setTimeout(() => {
                        this.hideCollectSuccessAnim = true
                    }, 300)
                })
            },
            clickHandler () {
                if (typeof this.clickCallBack === 'function') {
                    this.clickCallBack()
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .mark-btn {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        user-select: none;

        .lottie-wrap {
            width: 24px;
            height: 24px;
            overflow: hidden;

            div {
                margin: 0 !important;
            }

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>
